import { cva, type VariantProps } from 'class-variance-authority';

export const segmentedControlListVariants = cva('flex', {
    variants: {
        variant: {
            pills: 'flex-wrap gap-3',
            tabs: 'min-w-0 max-w-full overflow-x-auto pb-1 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden',
            underline:
                'min-w-0 max-w-full overflow-x-auto [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden',
        },
    },
    defaultVariants: {
        variant: 'pills',
    },
});

export const segmentedControlTrackVariants = cva('', {
    variants: {
        variant: {
            pills: 'contents',
            tabs: 'inline-flex w-max items-center rounded-2xl border border-border/80 bg-surface p-0.5 text-muted-foreground shadow-sm',
            underline: 'flex w-full min-w-max items-center gap-1 border-b border-border',
        },
    },
    defaultVariants: {
        variant: 'pills',
    },
});

export const segmentedControlButtonVariants = cva(
    'inline-flex shrink-0 items-center justify-center whitespace-nowrap text-sm font-medium transition-[background-color,border-color,color,box-shadow,transform] duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 motion-safe:active:scale-[0.98]',
    {
        variants: {
            variant: {
                pills: 'min-h-11 gap-3 rounded-full border px-4 py-2.5',
                tabs: 'h-9 gap-2 rounded-xl border border-transparent px-4',
                underline:
                    '-mb-px h-auto gap-2 rounded-none border-0 border-b-2 border-transparent px-3 pb-3 pt-2',
            },
            active: {
                true: '',
                false: '',
            },
        },
        compoundVariants: [
            {
                variant: 'pills',
                active: true,
                className: 'border-brand/20 bg-brand-subtle text-brand shadow-sm',
            },
            {
                variant: 'pills',
                active: false,
                className: 'border-border bg-card text-foreground hover:bg-surface-muted',
            },
            {
                variant: 'tabs',
                active: true,
                className: 'border-brand/25 bg-brand-subtle text-brand shadow-sm',
            },
            {
                variant: 'tabs',
                active: false,
                className: 'text-muted-foreground hover:text-foreground',
            },
            {
                variant: 'underline',
                active: true,
                className: 'border-brand text-brand',
            },
            {
                variant: 'underline',
                active: false,
                className: 'text-muted-foreground hover:text-foreground',
            },
        ],
        defaultVariants: {
            variant: 'pills',
            active: false,
        },
    },
);

export const segmentedCountVariants = cva(
    'inline-flex min-w-7 items-center justify-center rounded-full px-2 py-1 text-xs font-semibold tabular-nums leading-none',
    {
        variants: {
            active: {
                true: 'bg-card text-brand',
                false: 'bg-surface-muted text-muted-foreground',
            },
        },
        defaultVariants: {
            active: false,
        },
    },
);

export type SegmentedControlVariant = NonNullable<
    VariantProps<typeof segmentedControlListVariants>['variant']
>;
